if (!customElements.get('pdp-info-drawer')) {
  class PdpInfoDrawer extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.drawer = null;
      this.closeButton = null;
      this.observer = null;
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-pdp-info-drawer-trigger]');
      this.drawer = this.querySelector('theme-drawer');
      this.closeButton = this.querySelector('[data-pdp-info-drawer-close]');

      if (!this.trigger || !this.drawer) return;

      if (this.drawer.parentElement !== document.body) {
        document.body.appendChild(this.drawer);
      }

      this.trigger.addEventListener('click', this.handleTriggerClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);

      this.observer = new MutationObserver(() => this._syncExpanded());
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['data-open'] });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.trigger?.removeEventListener('click', this.handleTriggerClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.drawer?.remove();
      this.trigger = null;
      this.drawer = null;
      this.closeButton = null;
    }

    handleTriggerClick() {
      this.drawer.toggle();
      if (this.drawer.hasAttribute('data-open')) {
        this.closeButton?.focus({ preventScroll: true });
      }
    }

    handleCloseClick() {
      this.drawer.close();
    }

    _syncExpanded() {
      this.trigger.setAttribute('aria-expanded', String(this.drawer.hasAttribute('data-open')));
    }
  }

  customElements.define('pdp-info-drawer', PdpInfoDrawer);
}
